export const instrumentExcelConfig = [
  {
    header: 'DESCRIPTION',
    dataPath: 'instrument_type',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'SOURCE (H/OS)',
    dataPath: 'source',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'ID NO.',
    dataPath: 'id_no',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'MAKE',
    dataPath: 'make',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'DEPARTMENT',
    dataPath: 'department?.department_name',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'RANGE',
    dataPath: 'range',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'LEAST COUNT',
    dataPath: 'least_count',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'FREQUENCY',
    dataPath: 'frequency_in_year',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'INSTRUMENT STATUS',
    dataPath: 'instrument_status',
    autoWidth: true,
    xCenter: true,
    yCenter: true,
    valueFunction: (rowData:any) => {
      const status = rowData.instrument_status;
      let style = {};
      
      if (status === 'ACTIVE') {
        style = { backgroundColor: '#84a98c' };
      } else if (status === 'OBSOLETE') {
        style = { backgroundColor: '#e9c46a' };
      }
      
      return {
        value: status || '',
        style
      };
    }
  },
  {
    header: 'CALIBRATION ON',
    dataPath: 'calibration_done_date',
    isDate: true,
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'CALIBRATION DUE ON',
    dataPath: 'due_date',
    autoWidth: true,
    xCenter: true,
    yCenter: true,
    valueFunction: (rowData:any) => {
      const dueDate = rowData.due_date;
      
      // Calculate days difference to determine color
      const dueDateObj = dueDate ? new Date(dueDate.split('/').reverse().join('-')) : null;
      const currentDate = new Date();
      let style = {};
      
      if (dueDateObj) {
        const daysDiff = (dueDateObj.getTime() - currentDate.getTime()) / (1000 * 3600 * 24);
        
        if (daysDiff < 0) {
          style = { backgroundColor: '#e63946' }; // Overdue
        } else if (daysDiff < 30) {
          style = { backgroundColor: '#f6bd60' }; // Due soon
        }
      }
      
      return {
        value: dueDate || '',
        style
      };
    }
  },
  {
    header: 'DELAY IF ANY',
    dataPath: 'delay',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'ACCEPTANCE CRITERIA',
    dataPath: 'acceptence_criteria',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'REMARKS',
    dataPath: 'remarks',
    autoWidth: true,
    xCenter: true,
    yCenter: true
  },
  {
    header: 'FILES',
    dataPath: 'files',
    isFile: true,
    autoWidth: true,
    xCenter: true,
    yCenter: true
  }
];